export const RESOURCES = ['*', 'knowledge', 'agent', 'configuration', 'model'] as const;

export const ACTIONS_BY_RESOURCE = {
  '*': ['*'],
  knowledge: ['*', 'read', 'write', 'delete'],
  agent: ['*', 'access'],
  configuration: ['*', 'access'],
  model: ['*', 'access'],
} as const;

type AnyString = {} & string;
type BaseResource = (typeof RESOURCES)[number];

export type Resource = BaseResource | AnyString;
export type Action<R> = R extends BaseResource
  ? (typeof ACTIONS_BY_RESOURCE)[R][number] | AnyString
  : string;
export type Scope = '*' | AnyString;

/**
 * Checks if a permission string matches a requested resource:action:scope.
 *
 * Wildcards (*) are supported on both sides:
 * - Permission side: `knowledge:read:*` grants read on all knowledges
 * - Caller side: pass `scope='*'` to check for any scope (e.g. "has any read on knowledge?")
 *
 * Examples:
 * - `matchesPermission('knowledge:read:*', 'knowledge', 'read', 'abc')` → true
 * - `matchesPermission('knowledge:read:abc', 'knowledge', 'read', '*')` → true
 * - `matchesPermission('*:*:*', 'knowledge', 'read', 'abc')` → true
 */
export function matchesPermission(
  permission: string,
  resource: string,
  action: string,
  scope: string,
): boolean {
  const [permResource, permAction, permScope] = permission.split(':');
  return (
    (permResource === '*' || permResource === resource) &&
    (permAction === '*' || permAction === action) &&
    (scope === '*' || permScope === '*' || permScope === scope)
  );
}
